export default __webpack_public_path__ + "static/media/vip4.b1cbb2f2.gif";